import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  ExportLassoDataModalContainer, type ExportLassoDataModalContainerProps,
} from './exportLassoDataModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    ExportLassoData: ExportLassoDataModalContainerProps;
  }
}
modalRenderer.register('ExportLassoData', ExportLassoDataModalContainer);
